module.exports = __webpack_public_path__ + "img/sHighwayB_350x350.cb6c3c4e.jpg";